import { __decorate } from "tslib";
import { AnyDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { EmailRecipientFilterType } from './Email.js';
import { ExampleReplacements } from './exampleReplacements.js';
export var EmailTemplateType;
(function (EmailTemplateType) {
    /**
     * Template created by the user to send manually
     */
    EmailTemplateType["SavedMembersEmail"] = "SavedMembersEmail";
    EmailTemplateType["SavedDocumentsEmail"] = "SavedDocumentsEmail";
    EmailTemplateType["SavedPaymentsEmail"] = "SavedPaymentsEmail";
    /**
     * Defaults
     */
    EmailTemplateType["DefaultMembersEmail"] = "DefaultMembersEmail";
    EmailTemplateType["DefaultReceivableBalancesEmail"] = "DefaultReceivableBalancesEmail";
    EmailTemplateType["SavedReceivableBalancesEmail"] = "SavedReceivableBalancesEmail";
    EmailTemplateType["DefaultOrdersEmail"] = "DefaultOrdersEmail";
    EmailTemplateType["DefaultDocumentsEmail"] = "DefaultDocumentsEmail";
    EmailTemplateType["DefaultPaymentsEmail"] = "DefaultPaymentsEmail";
    //
    EmailTemplateType["MembersExpirationReminder"] = "MembersExpirationReminder";
    EmailTemplateType["WebshopsExpirationReminder"] = "WebshopsExpirationReminder";
    EmailTemplateType["SingleWebshopExpirationReminder"] = "SingleWebshopExpirationReminder";
    EmailTemplateType["TrialWebshopsExpirationReminder"] = "TrialWebshopsExpirationReminder";
    EmailTemplateType["TrialMembersExpirationReminder"] = "TrialMembersExpirationReminder";
    EmailTemplateType["OrderNotification"] = "OrderNotification";
    EmailTemplateType["RegistrationConfirmation"] = "RegistrationConfirmation";
    EmailTemplateType["RegistrationTransferDetails"] = "RegistrationTransferDetails";
    EmailTemplateType["OrderConfirmationOnline"] = "OrderConfirmationOnline";
    EmailTemplateType["OrderConfirmationTransfer"] = "OrderConfirmationTransfer";
    EmailTemplateType["OrderConfirmationPOS"] = "OrderConfirmationPOS";
    EmailTemplateType["OrderReceivedTransfer"] = "OrderReceivedTransfer";
    EmailTemplateType["OrderOnlinePaymentFailed"] = "OrderOnlinePaymentFailed";
    /**
     * Tickets sent immediately after ordering
     */
    EmailTemplateType["TicketsConfirmation"] = "TicketsConfirmation";
    /**
     * Order received, tickets will follow when we receive your payment
     */
    EmailTemplateType["TicketsConfirmationTransfer"] = "TicketsConfirmationTransfer";
    /**
     * Order received, tickets sent, but need to get paid at entrance
     */
    EmailTemplateType["TicketsConfirmationPOS"] = "TicketsConfirmationPOS";
    /**
     * Tickets sent after payment is received
     */
    EmailTemplateType["TicketsReceivedTransfer"] = "TicketsReceivedTransfer";
    /**
     * Organization emails:
     */
    EmailTemplateType["OrganizationUnstableDNS"] = "OrganizationUnstableDNS";
    EmailTemplateType["OrganizationInvalidDNS"] = "OrganizationInvalidDNS";
    EmailTemplateType["OrganizationValidDNS"] = "OrganizationValidDNS";
    EmailTemplateType["OrganizationStableDNS"] = "OrganizationStableDNS";
    EmailTemplateType["OrganizationDNSSetupComplete"] = "OrganizationDNSSetupComplete";
    // Drip emails
    EmailTemplateType["OrganizationDripWelcome"] = "OrganizationDripWelcome";
    EmailTemplateType["OrganizationDripWebshopTrialCheckin"] = "OrganizationDripWebshopTrialCheckin";
    EmailTemplateType["OrganizationDripMembersTrialCheckin"] = "OrganizationDripMembersTrialCheckin";
    EmailTemplateType["OrganizationDripWebshopTrialExpired"] = "OrganizationDripWebshopTrialExpired";
    EmailTemplateType["OrganizationDripMembersTrialExpired"] = "OrganizationDripMembersTrialExpired";
    EmailTemplateType["OrganizationDripTrialExpiredReminder"] = "OrganizationDripTrialExpiredReminder";
    EmailTemplateType["OrganizationDripWebshopNotRenewed"] = "OrganizationDripWebshopNotRenewed";
    EmailTemplateType["OrganizationDripMembersNotRenewed"] = "OrganizationDripMembersNotRenewed";
    /**
     * Exports
     */
    EmailTemplateType["ExcelExportSucceeded"] = "ExcelExportSucceeded";
    EmailTemplateType["ExcelExportFailed"] = "ExcelExportFailed";
    /**
     * User emails
     */
    EmailTemplateType["ForgotPasswordButNoAccount"] = "ForgotPasswordButNoAccount";
    EmailTemplateType["ForgotPassword"] = "ForgotPassword";
    EmailTemplateType["SignupAlreadyHasAccount"] = "SignupAlreadyHasAccount";
    EmailTemplateType["VerifyEmail"] = "VerifyEmail";
    EmailTemplateType["VerifyEmailWithoutCode"] = "VerifyEmailWithoutCode";
    EmailTemplateType["AdminInvitation"] = "AdminInvitation";
    EmailTemplateType["AdminInvitationNewUser"] = "AdminInvitationNewUser";
    EmailTemplateType["DeleteAccountConfirmation"] = "DeleteAccountConfirmation";
    /**
     * Balances
     */
    /**
     * E-mail sent to the user when their balance went up.
     * E.g. end of trial, manually added a balance item...
     */
    EmailTemplateType["UserBalanceIncreaseNotification"] = "UserBalanceIncreaseNotification";
    EmailTemplateType["OrganizationBalanceIncreaseNotification"] = "OrganizationBalanceIncreaseNotification";
    /**
     * A reminder e-mail to the user that their balance has to be paid.
     */
    EmailTemplateType["UserBalanceReminder"] = "UserBalanceReminder";
    EmailTemplateType["OrganizationBalanceReminder"] = "OrganizationBalanceReminder";
    /**
     * Event notifications
     */
    EmailTemplateType["EventNotificationSubmittedCopy"] = "EventNotificationSubmittedCopy";
    EmailTemplateType["EventNotificationSubmittedReviewer"] = "EventNotificationSubmittedReviewer";
    EmailTemplateType["EventNotificationAccepted"] = "EventNotificationAccepted";
    EmailTemplateType["EventNotificationRejected"] = "EventNotificationRejected";
    EmailTemplateType["EventNotificationPartiallyAccepted"] = "EventNotificationPartiallyAccepted";
    /**
     * Invoices
     */
    EmailTemplateType["InvoiceGenerationErrors"] = "InvoiceGenerationErrors";
    EmailTemplateType["InvoicePaid"] = "InvoicePaid";
    EmailTemplateType["CreditNotePaid"] = "CreditNotePaid";
    EmailTemplateType["InvoiceUnpaid"] = "InvoiceUnpaid";
    EmailTemplateType["CreditNoteUnpaid"] = "CreditNoteUnpaid";
    /**
     * Payments
     */
    EmailTemplateType["ChargebackPayingOrganization"] = "ChargebackPayingOrganization";
    /**
     * Only used for:
     * - Fast payment methods (creditcard) initiated by the payee
     * - Slow payment methods (direct debit)
     *
     * Not for failed transfer or point of sale.
     */
    EmailTemplateType["AutomaticChargeFailedPayingOrganization"] = "AutomaticChargeFailedPayingOrganization";
})(EmailTemplateType || (EmailTemplateType = {}));
export class EmailTemplate extends AutoEncoder {
    id;
    organizationId = null;
    subject = '';
    type = EmailTemplateType.SavedMembersEmail;
    html = '';
    text = '';
    json = {};
    groupId = null;
    webshopId = null;
    createdAt = new Date();
    updatedAt = new Date();
    static getDefaultForRecipient(type) {
        if (type === EmailRecipientFilterType.Members || type === EmailRecipientFilterType.MemberParents || type === EmailRecipientFilterType.RegistrationMembers || type === EmailRecipientFilterType.RegistrationParents) {
            return EmailTemplateType.DefaultMembersEmail;
        }
        if (type === EmailRecipientFilterType.ReceivableBalances) {
            return EmailTemplateType.DefaultReceivableBalancesEmail;
        }
        if (type === EmailRecipientFilterType.Orders) {
            return EmailTemplateType.DefaultOrdersEmail;
        }
        if (type === EmailRecipientFilterType.Documents) {
            return EmailTemplateType.DefaultDocumentsEmail;
        }
        if (type === EmailRecipientFilterType.Payment || type === EmailRecipientFilterType.PaymentOrganization) {
            return EmailTemplateType.DefaultPaymentsEmail;
        }
        return null;
    }
    static getSavedForRecipient(type) {
        if (type === EmailRecipientFilterType.Members || type === EmailRecipientFilterType.MemberParents || type === EmailRecipientFilterType.RegistrationMembers || type === EmailRecipientFilterType.RegistrationParents) {
            return EmailTemplateType.SavedMembersEmail;
        }
        if (type === EmailRecipientFilterType.ReceivableBalances) {
            return EmailTemplateType.SavedReceivableBalancesEmail;
        }
        if (type === EmailRecipientFilterType.Documents) {
            return EmailTemplateType.SavedDocumentsEmail;
        }
        if (type === EmailRecipientFilterType.Payment || type === EmailRecipientFilterType.PaymentOrganization) {
            return EmailTemplateType.SavedPaymentsEmail;
        }
        return null;
    }
    static isSavedEmail(type) {
        const savedEmailTemplateTypes = new Set([
            EmailTemplateType.SavedMembersEmail,
            EmailTemplateType.SavedReceivableBalancesEmail,
            EmailTemplateType.SavedDocumentsEmail,
            EmailTemplateType.SavedPaymentsEmail,
        ]);
        return savedEmailTemplateTypes.has(type);
    }
    static getTypeTitle(type) {
        switch (type) {
            case EmailTemplateType.SavedMembersEmail: return $t(`%p9`);
            case EmailTemplateType.SavedReceivableBalancesEmail: return $t(`%pA`);
            case EmailTemplateType.SavedDocumentsEmail: return $t('%1KM');
            case EmailTemplateType.SavedPaymentsEmail: return $t('%1N3');
            case EmailTemplateType.DefaultMembersEmail: return $t(`%pB`);
            case EmailTemplateType.DefaultReceivableBalancesEmail: return $t(`%pC`);
            case EmailTemplateType.DefaultOrdersEmail: return $t(`%pD`);
            case EmailTemplateType.DefaultDocumentsEmail: return $t('%1KN');
            case EmailTemplateType.DefaultPaymentsEmail: return $t('%1N4');
            case EmailTemplateType.MembersExpirationReminder: return $t(`%pE`);
            case EmailTemplateType.WebshopsExpirationReminder: return $t(`%pF`);
            case EmailTemplateType.SingleWebshopExpirationReminder: return $t(`%pG`);
            case EmailTemplateType.TrialWebshopsExpirationReminder: return $t(`%pH`);
            case EmailTemplateType.TrialMembersExpirationReminder: return $t(`%pI`);
            case EmailTemplateType.OrderNotification: return $t(`%pJ`);
            case EmailTemplateType.RegistrationConfirmation: return $t(`%pK`);
            case EmailTemplateType.RegistrationTransferDetails: return $t(`%pL`);
            case EmailTemplateType.OrderConfirmationOnline: return $t(`%pM`);
            case EmailTemplateType.OrderConfirmationTransfer: return $t(`%pN`);
            case EmailTemplateType.OrderConfirmationPOS: return $t(`%pO`);
            case EmailTemplateType.OrderReceivedTransfer: return $t(`%pP`);
            case EmailTemplateType.OrderOnlinePaymentFailed: return $t(`%pQ`);
            case EmailTemplateType.TicketsConfirmation: return $t(`%pR`);
            case EmailTemplateType.TicketsConfirmationTransfer: return $t(`%pS`);
            case EmailTemplateType.TicketsConfirmationPOS: return $t(`%pT`);
            case EmailTemplateType.TicketsReceivedTransfer: return $t(`%pU`);
            case EmailTemplateType.OrganizationUnstableDNS: return $t(`%pV`);
            case EmailTemplateType.OrganizationInvalidDNS: return $t(`%pW`);
            case EmailTemplateType.OrganizationValidDNS: return $t(`%pX`);
            case EmailTemplateType.OrganizationStableDNS: return $t(`%pY`);
            case EmailTemplateType.OrganizationDNSSetupComplete: return $t(`%pZ`);
            case EmailTemplateType.OrganizationDripWelcome: return $t(`%pa`);
            case EmailTemplateType.OrganizationDripWebshopTrialCheckin: return $t(`%pb`);
            case EmailTemplateType.OrganizationDripMembersTrialCheckin: return $t(`%pc`);
            case EmailTemplateType.OrganizationDripWebshopTrialExpired: return $t(`%pd`);
            case EmailTemplateType.OrganizationDripMembersTrialExpired: return $t(`%pe`);
            case EmailTemplateType.OrganizationDripTrialExpiredReminder: return $t(`%pf`);
            case EmailTemplateType.OrganizationDripWebshopNotRenewed: return $t(`%pg`);
            case EmailTemplateType.OrganizationDripMembersNotRenewed: return $t(`%ph`);
            case EmailTemplateType.ExcelExportSucceeded: return $t(`%pi`);
            case EmailTemplateType.ExcelExportFailed: return $t(`%pj`);
            case EmailTemplateType.SignupAlreadyHasAccount: return $t(`%pk`);
            case EmailTemplateType.ForgotPasswordButNoAccount: return $t(`%pl`);
            case EmailTemplateType.ForgotPassword: return $t(`%uz`);
            case EmailTemplateType.DeleteAccountConfirmation: return $t(`%pm`);
            case EmailTemplateType.VerifyEmail: return $t(`%pn`);
            case EmailTemplateType.VerifyEmailWithoutCode: return $t(`%po`);
            case EmailTemplateType.AdminInvitation: return $t(`%pp`);
            case EmailTemplateType.AdminInvitationNewUser: return $t(`%pq`);
            case EmailTemplateType.UserBalanceIncreaseNotification: return $t(`%pr`);
            case EmailTemplateType.UserBalanceReminder: return $t(`%ps`);
            case EmailTemplateType.OrganizationBalanceIncreaseNotification: return $t(`%pr`);
            case EmailTemplateType.OrganizationBalanceReminder: return $t(`%ps`);
            case EmailTemplateType.EventNotificationSubmittedCopy: return $t('%Ai');
            case EmailTemplateType.EventNotificationSubmittedReviewer: return $t('%Aj');
            case EmailTemplateType.EventNotificationAccepted: return $t('%Ak');
            case EmailTemplateType.EventNotificationRejected: return $t('%Al');
            case EmailTemplateType.EventNotificationPartiallyAccepted: return $t('%Cl');
            case EmailTemplateType.InvoiceGenerationErrors: return $t('%1Sm');
            case EmailTemplateType.InvoicePaid: return $t('Factuur (na betaling)');
            case EmailTemplateType.CreditNotePaid: return $t('Creditnota (na betaling)');
            case EmailTemplateType.InvoiceUnpaid: return $t('Factuur te betalen');
            case EmailTemplateType.CreditNoteUnpaid: return $t('Creditnota te betalen');
            case EmailTemplateType.ChargebackPayingOrganization: return $t('Betaling teruggevorderd');
            case EmailTemplateType.AutomaticChargeFailedPayingOrganization: return $t('Betaling mislukt');
        }
    }
    static getTypeCategory(type) {
        switch (type) {
            case EmailTemplateType.SavedMembersEmail:
            case EmailTemplateType.SavedReceivableBalancesEmail:
            case EmailTemplateType.SavedPaymentsEmail:
            case EmailTemplateType.SavedDocumentsEmail:
                return $t(`%pt`);
            case EmailTemplateType.DefaultMembersEmail:
            case EmailTemplateType.DefaultReceivableBalancesEmail:
            case EmailTemplateType.DefaultOrdersEmail:
            case EmailTemplateType.DefaultPaymentsEmail:
            case EmailTemplateType.DefaultDocumentsEmail:
                return $t(`%Q`);
            case EmailTemplateType.MembersExpirationReminder:
            case EmailTemplateType.WebshopsExpirationReminder:
            case EmailTemplateType.SingleWebshopExpirationReminder:
            case EmailTemplateType.TrialWebshopsExpirationReminder:
            case EmailTemplateType.TrialMembersExpirationReminder:
                return $t(`%1v`);
            case EmailTemplateType.RegistrationConfirmation:
            case EmailTemplateType.RegistrationTransferDetails:
                return $t(`%1EI`);
            case EmailTemplateType.OrderNotification:
                return $t(`%2N`);
            case EmailTemplateType.OrderConfirmationOnline:
            case EmailTemplateType.OrderConfirmationTransfer:
            case EmailTemplateType.OrderConfirmationPOS:
            case EmailTemplateType.OrderReceivedTransfer:
            case EmailTemplateType.OrderOnlinePaymentFailed:
                return $t(`%pu`);
            case EmailTemplateType.TicketsConfirmation:
            case EmailTemplateType.TicketsConfirmationTransfer:
            case EmailTemplateType.TicketsConfirmationPOS:
            case EmailTemplateType.TicketsReceivedTransfer:
                return $t(`%pv`);
            case EmailTemplateType.OrganizationUnstableDNS:
            case EmailTemplateType.OrganizationInvalidDNS:
            case EmailTemplateType.OrganizationValidDNS:
            case EmailTemplateType.OrganizationStableDNS:
            case EmailTemplateType.OrganizationDNSSetupComplete:
                return $t(`%26`);
            case EmailTemplateType.OrganizationDripWelcome:
            case EmailTemplateType.OrganizationDripWebshopTrialCheckin:
            case EmailTemplateType.OrganizationDripMembersTrialCheckin:
            case EmailTemplateType.OrganizationDripWebshopTrialExpired:
            case EmailTemplateType.OrganizationDripMembersTrialExpired:
            case EmailTemplateType.OrganizationDripTrialExpiredReminder:
            case EmailTemplateType.OrganizationDripWebshopNotRenewed:
            case EmailTemplateType.OrganizationDripMembersNotRenewed:
                return $t(`%25`);
            case EmailTemplateType.ExcelExportSucceeded:
            case EmailTemplateType.ExcelExportFailed:
                return $t(`%1u`);
            case EmailTemplateType.SignupAlreadyHasAccount:
            case EmailTemplateType.ForgotPasswordButNoAccount:
            case EmailTemplateType.ForgotPassword:
            case EmailTemplateType.DeleteAccountConfirmation:
            case EmailTemplateType.VerifyEmail:
            case EmailTemplateType.VerifyEmailWithoutCode:
                return $t(`%pw`);
            case EmailTemplateType.AdminInvitation:
            case EmailTemplateType.AdminInvitationNewUser:
                return $t(`%px`);
            case EmailTemplateType.UserBalanceIncreaseNotification:
            case EmailTemplateType.UserBalanceReminder:
                return $t(`%py`);
            case EmailTemplateType.OrganizationBalanceIncreaseNotification:
            case EmailTemplateType.OrganizationBalanceReminder:
                return $t(`%pz`);
            case EmailTemplateType.EventNotificationSubmittedCopy:
            case EmailTemplateType.EventNotificationSubmittedReviewer:
            case EmailTemplateType.EventNotificationAccepted:
            case EmailTemplateType.EventNotificationRejected:
            case EmailTemplateType.EventNotificationPartiallyAccepted:
                return $t('%CV');
            case EmailTemplateType.InvoiceGenerationErrors:
            case EmailTemplateType.InvoicePaid:
            case EmailTemplateType.CreditNotePaid:
            case EmailTemplateType.InvoiceUnpaid:
            case EmailTemplateType.CreditNoteUnpaid:
                return $t('%1Mm');
            case EmailTemplateType.ChargebackPayingOrganization:
            case EmailTemplateType.AutomaticChargeFailedPayingOrganization:
                return $t('Betalingen');
        }
    }
    static allowPlatformLevel(type) {
        if (STAMHOOFD.userMode === 'platform') {
            if (type.includes('Drip') || type.includes('Expiration')) {
                return false;
            }
        }
        switch (type) {
            case EmailTemplateType.ChargebackPayingOrganization:
            case EmailTemplateType.AutomaticChargeFailedPayingOrganization:
                return STAMHOOFD.userMode === 'organization';
        }
        return true;
    }
    static allowOrganizationLevelInGeneral(type) {
        switch (type) {
            case EmailTemplateType.DefaultMembersEmail: return true;
            case EmailTemplateType.DefaultReceivableBalancesEmail: return true;
            case EmailTemplateType.DefaultOrdersEmail: return true;
            case EmailTemplateType.DefaultDocumentsEmail: return true;
            case EmailTemplateType.DefaultPaymentsEmail: return true;
            case EmailTemplateType.SavedMembersEmail: return true;
            case EmailTemplateType.SavedReceivableBalancesEmail: return true;
            case EmailTemplateType.SavedDocumentsEmail: return true;
            case EmailTemplateType.SavedPaymentsEmail: return true;
            case EmailTemplateType.RegistrationConfirmation: return true;
            case EmailTemplateType.RegistrationTransferDetails: return true;
            case EmailTemplateType.OrderConfirmationOnline: return true;
            case EmailTemplateType.OrderConfirmationTransfer: return true;
            case EmailTemplateType.OrderConfirmationPOS: return true;
            case EmailTemplateType.OrderReceivedTransfer: return true;
            case EmailTemplateType.TicketsConfirmation: return true;
            case EmailTemplateType.TicketsConfirmationTransfer: return true;
            case EmailTemplateType.TicketsConfirmationPOS: return true;
            case EmailTemplateType.TicketsReceivedTransfer: return true;
            case EmailTemplateType.UserBalanceIncreaseNotification: return true;
            case EmailTemplateType.UserBalanceReminder: return true;
            case EmailTemplateType.OrganizationBalanceIncreaseNotification: return true;
            case EmailTemplateType.OrganizationBalanceReminder: return true;
        }
        return false;
    }
    static allowOrganizationLevel(type, organization, platform) {
        if (!organization) {
            return false;
        }
        if (!organization.privateMeta?.featureFlags.includes('organization-receivable-balances')
            && [EmailTemplateType.OrganizationBalanceIncreaseNotification, EmailTemplateType.OrganizationBalanceReminder].includes(type)) {
            return false;
        }
        switch (type) {
            case EmailTemplateType.ChargebackPayingOrganization:
            case EmailTemplateType.AutomaticChargeFailedPayingOrganization:
                return STAMHOOFD.userMode === 'organization' && organization.id === platform.membershipOrganizationId;
        }
        return this.allowOrganizationLevelInGeneral(type);
    }
    static getPlatformTypeDescription(type) {
        switch (type) {
            case EmailTemplateType.OrganizationUnstableDNS: return $t(`%q0`);
            case EmailTemplateType.OrganizationInvalidDNS: return $t(`%q1`);
            case EmailTemplateType.OrganizationValidDNS: return $t(`%q2`);
            case EmailTemplateType.OrganizationStableDNS: return $t(`%q3`);
            case EmailTemplateType.OrganizationDNSSetupComplete: return $t(`%q4`);
            case EmailTemplateType.OrderOnlinePaymentFailed: return $t(`%q5`);
            case EmailTemplateType.ExcelExportSucceeded: return $t(`%q6`);
            case EmailTemplateType.ExcelExportFailed: return $t(`%q7`);
            case EmailTemplateType.ForgotPasswordButNoAccount: return $t(`%q8`);
            case EmailTemplateType.ForgotPassword: return $t(`%q9`);
            case EmailTemplateType.DeleteAccountConfirmation: return $t(`%qA`);
            case EmailTemplateType.VerifyEmail: return $t(`%qB`);
            case EmailTemplateType.VerifyEmailWithoutCode: return $t(`%qC`);
            case EmailTemplateType.AdminInvitation: return $t(`%qD`);
            case EmailTemplateType.AdminInvitationNewUser: return $t(`%qE`);
            case EmailTemplateType.SignupAlreadyHasAccount: return $t(`%qF`);
            case EmailTemplateType.EventNotificationSubmittedCopy: return $t('%Am');
            case EmailTemplateType.EventNotificationSubmittedReviewer: return $t('%An');
            case EmailTemplateType.EventNotificationAccepted: return $t('%Ao');
            case EmailTemplateType.EventNotificationRejected: return $t('%Ap');
            case EmailTemplateType.EventNotificationPartiallyAccepted: return $t('%Cm');
        }
        return null;
    }
    /**
     * Return true if this template type contains recipient types where EmailRecipientFilter.canShowInMemberPortal = true.
     * This means that you can send an email that will also be visible in the member portal. When this is the case, you should be able to add a block to
     * an email that is only visible when sent via email.
     *
     * Note: please also update EmailRecipientFilter.canShowInMemberPortal
     * @returns
     */
    static canAddEmailOnlyContent(type) {
        switch (type) {
            case EmailTemplateType.SavedMembersEmail:
            case EmailTemplateType.SavedDocumentsEmail:
            case EmailTemplateType.SavedPaymentsEmail:
            case EmailTemplateType.DefaultDocumentsEmail:
            case EmailTemplateType.UserBalanceReminder: // special case because it is sent via a cron
            case EmailTemplateType.UserBalanceIncreaseNotification:
            case EmailTemplateType.DefaultPaymentsEmail:
            case EmailTemplateType.DefaultMembersEmail: {
                return true;
            }
        }
        return false;
    }
    static getTypeDescription(type) {
        switch (type) {
            case EmailTemplateType.DefaultMembersEmail: return $t(`%qG`);
            case EmailTemplateType.DefaultReceivableBalancesEmail: return $t(`%qH`);
            case EmailTemplateType.DefaultOrdersEmail: return $t(`%qI`);
            case EmailTemplateType.DefaultDocumentsEmail: return $t('%1KO');
            case EmailTemplateType.DefaultPaymentsEmail: return $t('%1N5');
            case EmailTemplateType.OrderNotification: return $t(`%qJ`);
            case EmailTemplateType.RegistrationConfirmation: return $t(`%qK`);
            case EmailTemplateType.OrderConfirmationOnline: return $t(`%qL`);
            case EmailTemplateType.OrderConfirmationTransfer: return $t(`%qM`);
            case EmailTemplateType.OrderConfirmationPOS: return $t(`%qN`);
            case EmailTemplateType.OrderReceivedTransfer: return $t(`%qO`);
            case EmailTemplateType.TicketsConfirmation: return $t(`%qL`);
            case EmailTemplateType.TicketsConfirmationTransfer: return $t(`%qM`);
            case EmailTemplateType.TicketsConfirmationPOS: return $t(`%qN`);
            case EmailTemplateType.TicketsReceivedTransfer: return $t(`%qO`);
            case EmailTemplateType.UserBalanceIncreaseNotification: return $t(`Automatische e-mail die 's ochtends wordt verzonden als het saldo van een gebruiker omhoog is gegaan. Bijvoorbeeld als iemand een openstaand bedrag heeft toegevoegd bij een lid.`);
            case EmailTemplateType.UserBalanceReminder: return $t(`Automatische e-mail die 's ochtends wordt verzonden als een gebruiker nog steeds een openstaand bedrag heeft.`);
            case EmailTemplateType.OrganizationBalanceIncreaseNotification: return $t(`Automatische e-mail die 's ochtends wordt verzonden als het saldo van een groep omhoog is gegaan.`);
            case EmailTemplateType.OrganizationBalanceReminder: return $t(`Automatische e-mail die 's ochtends wordt verzonden als een groep nog steeds een openstaand bedrag heeft.`);
            case EmailTemplateType.ChargebackPayingOrganization: return $t('Automatische email naar schuldenaar als een betaling werd teruggevorderd, bv. een SEPA domiciliering die is mislukt.');
            case EmailTemplateType.AutomaticChargeFailedPayingOrganization: return $t('Automatische email naar schuldenaar als een betaling is mislukt die werd geïniteerd door de schuldeiser (bv. via opgeslagen creditcard)');
        }
        return '';
    }
    static getSupportedReplacementsForType(type) {
        if ([
            EmailTemplateType.EventNotificationSubmittedCopy,
            EmailTemplateType.EventNotificationSubmittedReviewer,
            EmailTemplateType.EventNotificationAccepted,
            EmailTemplateType.EventNotificationRejected,
            EmailTemplateType.EventNotificationPartiallyAccepted,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.reviewUrl,
                ExampleReplacements.all.submitterName,
                ExampleReplacements.all.organizationName,
                ExampleReplacements.all.eventName,
                ExampleReplacements.all.dateRange,
                ...(type === EmailTemplateType.EventNotificationRejected || type === EmailTemplateType.EventNotificationPartiallyAccepted ? [ExampleReplacements.all.feedbackText] : []),
            ];
        }
        if ([
            EmailTemplateType.InvoicePaid,
            EmailTemplateType.CreditNotePaid,
            EmailTemplateType.InvoiceUnpaid,
            EmailTemplateType.CreditNoteUnpaid,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.invoiceNumber,
                ExampleReplacements.all.totalPrice,
            ];
        }
        if ([
            EmailTemplateType.InvoiceGenerationErrors,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.errors,
            ];
        }
        if ([
            EmailTemplateType.DefaultReceivableBalancesEmail,
            EmailTemplateType.SavedReceivableBalancesEmail,
            EmailTemplateType.UserBalanceIncreaseNotification,
            EmailTemplateType.UserBalanceReminder,
            EmailTemplateType.OrganizationBalanceIncreaseNotification,
            EmailTemplateType.OrganizationBalanceReminder,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.paymentUrl,
                ExampleReplacements.all.outstandingBalance,
                ExampleReplacements.all.balanceTable,
                ExampleReplacements.all.objectName,
            ];
        }
        if ([
            EmailTemplateType.SavedMembersEmail,
            EmailTemplateType.DefaultMembersEmail,
            EmailTemplateType.DefaultDocumentsEmail,
            EmailTemplateType.SavedDocumentsEmail,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.firstNameMember,
                ExampleReplacements.all.lastNameMember,
                ExampleReplacements.all.outstandingBalance,
                ExampleReplacements.all.loginDetails,
                ExampleReplacements.all.balanceTable,
            ];
        }
        if (type === EmailTemplateType.SignupAlreadyHasAccount) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.resetUrl,
            ];
        }
        if (type === EmailTemplateType.ForgotPasswordButNoAccount) {
            return [
                ...ExampleReplacements.default,
                // Name not available
                ExampleReplacements.all.email,
            ];
        }
        if (type === EmailTemplateType.DeleteAccountConfirmation) {
            return ExampleReplacements.default;
        }
        if (type === EmailTemplateType.ForgotPassword) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.resetUrl,
            ];
        }
        if (type === EmailTemplateType.VerifyEmail) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.confirmEmailUrl,
                ExampleReplacements.all.confirmEmailCode,
            ];
        }
        if (type === EmailTemplateType.VerifyEmailWithoutCode) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.confirmEmailUrl,
            ];
        }
        if (type === EmailTemplateType.AdminInvitation) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.platformOrOrganizationName,
                ExampleReplacements.all.inviterName,
                ExampleReplacements.all.validUntil,
                ExampleReplacements.all.signInUrl,
                ExampleReplacements.all.resetUrl,
            ];
        }
        if (type === EmailTemplateType.AdminInvitationNewUser) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.platformOrOrganizationName,
                ExampleReplacements.all.inviterName,
                ExampleReplacements.all.validUntil,
                ExampleReplacements.all.resetUrl,
            ];
        }
        if (type === EmailTemplateType.ExcelExportSucceeded) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.downloadUrl,
            ];
        }
        if (type === EmailTemplateType.ExcelExportFailed) {
            return [
                ...ExampleReplacements.default,
            ];
        }
        if (type === EmailTemplateType.RegistrationConfirmation) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.firstNameMember,
                ExampleReplacements.all.lastNameMember,
                ExampleReplacements.all.registerUrl,
                ExampleReplacements.all.groupName,
                ExampleReplacements.all.signInUrl,
                ExampleReplacements.all.unsubscribeUrl,
                ExampleReplacements.all.loginDetails,
            ];
        }
        if ([
            EmailTemplateType.OrganizationDNSSetupComplete,
            EmailTemplateType.OrganizationInvalidDNS,
            EmailTemplateType.OrganizationStableDNS,
            EmailTemplateType.OrganizationUnstableDNS,
            EmailTemplateType.OrganizationValidDNS,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.mailDomain,
            ];
        }
        if (type === EmailTemplateType.RegistrationTransferDetails) {
            return [
                ExampleReplacements.all.priceToPay,
                ExampleReplacements.all.paymentMethod,
                ExampleReplacements.all.transferDescription,
                ExampleReplacements.all.transferBankAccount,
                ExampleReplacements.all.transferBankCreditor,
                ExampleReplacements.all.overviewContext,
                ExampleReplacements.all.memberNames,
                ExampleReplacements.all.overviewTable,
                ExampleReplacements.all.paymentTable,
                ExampleReplacements.all.registerUrl,
                ExampleReplacements.all.organizationName,
                ExampleReplacements.all.signInUrl,
                ExampleReplacements.all.unsubscribeUrl,
                ExampleReplacements.all.loginDetails,
            ];
        }
        if ([
            EmailTemplateType.MembersExpirationReminder,
            EmailTemplateType.WebshopsExpirationReminder,
            EmailTemplateType.TrialMembersExpirationReminder,
            EmailTemplateType.TrialWebshopsExpirationReminder,
            EmailTemplateType.SingleWebshopExpirationReminder,
        ].includes(type)) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.packageName,
                ExampleReplacements.all.validUntil,
                ExampleReplacements.all.validUntilDate,
                ExampleReplacements.all.renewUrl,
                ExampleReplacements.all.unsubscribeUrl,
            ];
        }
        if (type === EmailTemplateType.ChargebackPayingOrganization
            || type === EmailTemplateType.AutomaticChargeFailedPayingOrganization) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.paymentUrl,
                ExampleReplacements.all.payingOrganizationName,
                ExampleReplacements.all.platformName,
            ];
        }
        if (type === EmailTemplateType.DefaultPaymentsEmail
            || type === EmailTemplateType.SavedPaymentsEmail) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.priceToPay,
                ExampleReplacements.all.paymentMethod,
                ExampleReplacements.all.overviewTable,
                ExampleReplacements.all.paymentTable,
                ExampleReplacements.all.overviewContext,
                ExampleReplacements.all.paymentData,
                ExampleReplacements.all.paymentUrl,
            ];
        }
        if (type.toString().startsWith('OrganizationDrip')) {
            return [
                ...ExampleReplacements.default,
                ExampleReplacements.all.organizationName,
                ExampleReplacements.all.mailDomain,
            ];
        }
        const sharedReplacements = [
            ...ExampleReplacements.default,
            ExampleReplacements.all.orderPrice,
            ExampleReplacements.all.orderStatus,
            ExampleReplacements.all.orderDetailsTable,
            ExampleReplacements.all.orderTable,
            ExampleReplacements.all.paymentTable,
            ExampleReplacements.all.orderUrl,
            ExampleReplacements.all.paymentMethod,
            ExampleReplacements.all.organizationName,
            ExampleReplacements.all.webshopName,
            ExampleReplacements.all.unsubscribeUrl,
        ];
        if (type !== EmailTemplateType.OrderOnlinePaymentFailed) {
            sharedReplacements.push(ExampleReplacements.all.nr);
        }
        if (type === EmailTemplateType.OrderConfirmationTransfer || type === EmailTemplateType.TicketsConfirmationTransfer) {
            return [
                ...sharedReplacements,
                ExampleReplacements.all.transferDescription,
                ExampleReplacements.all.transferBankAccount,
                ExampleReplacements.all.transferBankCreditor,
            ];
        }
        return sharedReplacements;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], EmailTemplate.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailTemplate.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailTemplate.prototype, "subject", void 0);
__decorate([
    field({ decoder: new EnumDecoder(EmailTemplateType) })
], EmailTemplate.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailTemplate.prototype, "html", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailTemplate.prototype, "text", void 0);
__decorate([
    field({ decoder: AnyDecoder })
], EmailTemplate.prototype, "json", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailTemplate.prototype, "groupId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailTemplate.prototype, "webshopId", void 0);
__decorate([
    field({ decoder: DateDecoder, optional: true })
], EmailTemplate.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, optional: true })
], EmailTemplate.prototype, "updatedAt", void 0);
//# sourceMappingURL=EmailTemplate.js.map